export const TEN_MB = 10000000;
export const PT_BR = 'pt';
export const FULL = 'Full';